import script from "./HallticketPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HallticketPage.vue?vue&type=script&setup=true&lang=js"

import "./HallticketPage.vue?vue&type=style&index=0&id=528e46fa&lang=css"

const __exports__ = script;

export default __exports__